import { authenticatedApi } from '../../../shared/api/apiClientUtils.ts';

export interface UserLabourGroupAssignmentResponse {
  userId: string;
  email: string;
  fullName: string;
  labourGroupId: number | null;
  labourGroupName: string | null;
}

export const assignUserToLabourGroup = async (
  userId: string,
  groupId: number
): Promise<UserLabourGroupAssignmentResponse> => {
  const response =
    await authenticatedApi.put<UserLabourGroupAssignmentResponse>(
      `/api/v1/users/${userId}/labour-group/${groupId}`
    );
  return response.data;
};

export const removeUserFromLabourGroup = async (
  userId: string
): Promise<void> => {
  await authenticatedApi.delete(`/api/v1/users/${userId}/labour-group`);
};
